
export const services = {
  startingPrice: "Kezdőár",
  details: "Részletek",
  question: {
    title: "Tegyél fel kérdést",
    subtitle: "Privát üzenetek",
    description: "Kérdezz bármit, és személyes választ kapsz tőlem. Minden üzenetet én olvasok el és válaszolok meg."
  }
};
